import { MfaSetup } from '@/features/mfa'

const MfaSetupPage = () => <MfaSetup />

export default MfaSetupPage
